import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';

const request = createAppRequest();

export interface OpenPlatformM2mSession {
  accessToken: string;
  permissions: string;
  exp: number;
  iat: number;
  memberUuid: string;
}

export async function getOpenPlatformM2mToken(
  options?: ApiRequestOptions,
) {
  return request<OpenPlatformM2mSession>('/bff/open-platform/m2m-token', {
    method: 'POST',
    ...(options || {}),
  });
}
